
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SolarFlareEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const drawFlayer = (angle: number, length: number) => {
             ctx.beginPath();
             ctx.moveTo(0, 0);
             for (let i = 0; i < 10; i++) {
                 const step = length / 10;
                 const noise = Math.sin(curTime * 5 + i + angle) * 20 * scale;
                 const r = i * step;
                 const curAngle = angle + (Math.sin(curTime + i * 0.1) * 0.2);
                 ctx.lineTo(Math.cos(curAngle) * r + noise, Math.sin(curAngle) * r + noise);
             }
             ctx.lineWidth = (5 * scale) / (layerIndex + 1);
             ctx.stroke();
        };

        const draw = () => {
             const count = Math.floor(12 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < count; i++) {
                 const angle = (i / count) * Math.PI * 2 + curTime * 0.2;
                 drawFlayer(angle, 300 * scale);
             }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
